/**
 * A count with the noun it needs.
 *
 * Spelling the phrase at each site is what puts "1 users" and "1 of 1
 * programmes shown" on a screen: the plural is written once, the singular
 * case is the one nobody sees while building.
 *
 * @module components/ui/plural
 */

/**
 * @param count - How many.
 * @param singular - The noun for one.
 * @param plural - The noun for any other count. Defaults to `singular` + "s".
 *
 * @example
 * ```ts
 * countLabel(1, "user"); // "1 user"
 * countLabel(3, "entry", "entries"); // "3 entries"
 * ```
 */
export function countLabel(count: number, singular: string, plural?: string): string {
  return `${count} ${count === 1 ? singular : (plural ?? `${singular}s`)}`;
}

/** The noun alone, for a phrase that puts the count somewhere else. */
export function pluralNoun(count: number, singular: string, plural?: string): string {
  return count === 1 ? singular : (plural ?? `${singular}s`);
}
